import { memo } from 'react';
import { Row, Col } from 'react-bootstrap';
import { getScreenImage } from '../../../Domain/Utils/ScreenUtilies/ScreenUtilies';
import DotAccordion from '../../Molecules/DotAccordion/DotAccordion';
import {
  ID_MULTILANGUGAE,
  TYPE_FETCH_PARAMETERS
} from '../../../Domain/Settings/Constants/Constants';
import { certificado } from '../../../Resources/Images/ImagesLogo';
import {
  useGetComponentParameters,
  useGetMainComponentParameters
} from '../../../Core/Hooks/HooksParameters/useGetComponentParameters';
import { COMPONENTS } from '../../../Domain/Settings/Constants/ComponentsParameter/ComponentsParameter';

const BenefitsAndCertifications = ({ parameters, language, landing = false, isOnline = false }) => {
  const getParameterMain = () => {
    return isOnline
      ? parameters?.ALL_BENEFITS_CERTIFICATIONS_LANDING_ONLINE?.code
      : landing
      ? parameters?.ALL_BENEFITS_CERTIFICATIONS_LANDING?.code
      : parameters?.ALL_BENEFITS_CERTIFICATIONS?.code;
  };

  const getParameterTitle = () => {
    return landing
      ? parameters?.BENEFITS_CERTIFICATIONS_COURSE
      : parameters?.BENEFITS_CERTIFICATIONS;
  };

  const items =
    useGetMainComponentParameters(
      COMPONENTS.BENEFECITS_CERTIFICATIONS_SECTION,
      TYPE_FETCH_PARAMETERS.MAIN_MULTILANGUAGE,
      getParameterMain()
    ) || [];

  return (
    <section className="container py-4 justify-content-center">
      <h2
        aria-label="tile section"
        className="lt-text-title text-center text-white pb-lg-3 mb-lg-4">
        {getParameterTitle()?.value}{' '}
        <span style={{ color: 'var(--corporative-yellow)' }}>
          {getParameterTitle()?.description_value}
        </span>
      </h2>
      <Row className="mt-lg-2 mt-0 py-0 my-0">
        <Col lg={6} md={6}>
          <div
            className="d-flex justify-content-center align-items-center py-lg-0 py-4 my-1"
            style={{ borderRadius: '20px' }}>
            <img
              style={{ padding: '0px' }}
              alt="certification image"
              aria-label="certify image"
              className="w-md-100 w-75 "
              src={getScreenImage(parameters?.BENEFITS_CERTIFICATIONS) || certificado}
            />
          </div>
        </Col>
        <Col
          lg={6}
          md={6}
          className="d-flex flex-column h-100 mt-3 mx-auto align-items-lg-start justify-content-lg-start justify-content-start">
          <DotAccordion items={items} parameters={parameters} />
        </Col>
      </Row>
    </section>
  );
};

export default memo(BenefitsAndCertifications);
